import {createFileRoute} from '@tanstack/react-router'

// Catch-all for legacy wizard steps. The parent route redirects.
export const Route = createFileRoute('/_app/projects/$projectId/jobs/create/$')({})
